var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45012 34.8493L10.4398 31.5016L10.9532 25.6318L18.9331 18.9359L27.7107 11.5706L30.9026 8.8923C33.9875 6.30375 38.5867 6.70613 41.1753 9.79105C43.7638 12.876 43.3615 17.4752 40.2765 20.0638L37.0847 22.7421L28.3071 30.1073L20.3272 36.8033L14.4598 36.2924L10.473 39.6378C9.14922 40.7486 7.17567 40.5759 6.06492 39.2522C4.95548 37.93 5.12794 35.9587 6.45012 34.8493Z",
    stroke: "#00075e",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4365 9.71768L38.2075 27.321",
    stroke: "#00075e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5755 29.0001L24.3018 24.0001",
    stroke: "#00075e",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproch1);
export default __webpack_public_path__ + "static/media/approch_1.ba598761d0497c9bd2e2ca15ed6f9b59.svg";
export { ForwardRef as ReactComponent };